// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import * as initializers from './initializers/*.js'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: initializers.router,
  template: '<App v-if="appReady"/>',
  components: { App },
  data () {
    return {
      appReady: false
    }
  },
  created () {
    let required = _.chain(initializers).filter({required: true}).map("onReady").value()
    Promise.all(required).then(() => {
      this.appReady = true
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js